import { Brand, createBranded } from '@deltasierra/type-utilities';

export type CampaignMonitorReportId = Brand<number, 'CampaignMonitorReportId'>;
export const CampaignMonitorReportId = createBranded<CampaignMonitorReportId>();
